import { customElement, FASTElement, observable } from '@microsoft/fast-element';
import { UserManagementTemplate as template } from './user-management.template';
import { UserManagementStyles as styles } from './user-management.styles';
import { logger, PROFILE_RIGHTS } from '../../utils';
import { IUserService } from '../../services/user.service';
import { ICompanyService } from '../../services/company.service';

const name = 'user-management-route';
@customElement({
  name,
  template,
  styles,
})
export class UserManagement extends FASTElement {
  @IUserService userService: IUserService;
  @ICompanyService companyService: ICompanyService;

  @observable isAdmin: boolean = false;
  @observable isAdvisor: boolean = false;
  @observable gridOptions = {
    scrollbarWidth: 10,
  };

  public connectedCallback() {
    super.connectedCallback();
    this.isAdmin = this.userService.hasCascadeAdminRights();
    setTimeout(() => {
        this.isAdvisor = (
            !this.userService.hasAdvisorRights() ||
            (this.userService.getCurrentUser().COMPANY_ID == this.companyService.getCurrentCompany().CASCADE_COMPANY_ID)
        );
    }, 500
    )
    logger.debug(`${name} is now connected to the DOM`);
  }
}
